import gsap from 'gsap'

export class Blog {
  constructor() {
    this.grid = document.querySelector('.blog-articles__grid');
    this.filters = document.querySelectorAll('.blog-articles__filter');
    this.moreBtn = document.querySelector('.blog-articles__more');
    this.ppp = 6;
    this.offset = this.ppp;
    this.currentCat = 'all';

    this.initFilters();
    this.initLoadMore();

    // Animation initiale des cards déjà présentes
    this.animateCards(this.grid.querySelectorAll('.blog-card'));
  }

  animateCards(cards) {
    if (!cards.length) return;

    gsap.fromTo(cards, {
      opacity: 0,
      y: 40,
    }, {
      opacity: 1,
      y: 0,
      duration: 0.5,
      stagger: 0.08,
      ease: 'power2.out',
    });
  }

  initFilters() {
    this.filters.forEach(btn => {
      btn.addEventListener('click', () => {
        this.filters.forEach(f => f.classList.remove('is-active'));
        btn.classList.add('is-active');

        this.currentCat = btn.dataset.cat;
        this.offset = 0;

        // Fade out les cards existantes puis charger les nouvelles
        const currentCards = this.grid.querySelectorAll('.blog-card');

        if (currentCards.length) {
          gsap.to(currentCards, {
            opacity: 0,
            y: -20,
            duration: 0.25,
            stagger: 0.03,
            ease: 'power2.in',
            onComplete: () => this.loadPosts(true),
          });
        } else {
          this.loadPosts(true);
        }
      });
    });
  }

  initLoadMore() {
    if (!this.moreBtn) return;

    this.moreBtn.addEventListener('click', () => {
      this.loadPosts(false);
    });
  }

  loadPosts(replace) {
    const params = new URLSearchParams({
      action: 'filter_posts_ajax',
      ppp: this.ppp,
      offset: replace ? 0 : this.offset,
      cat: this.currentCat,
    });

    fetch(ajaxurl + '?' + params.toString())
      .then(res => res.json())
      .then(data => {
        // Compter les cards existantes avant insertion (pour le stagger des nouvelles)
        const existingCount = replace ? 0 : this.grid.querySelectorAll('.blog-card').length;

        if (replace) {
          this.grid.innerHTML = data.html;
          this.offset = this.ppp;
        } else {
          this.grid.insertAdjacentHTML('beforeend', data.html);
          this.offset += this.ppp;
        }

        // Animer les nouvelles cards uniquement
        const allCards = this.grid.querySelectorAll('.blog-card');
        const newCards = Array.from(allCards).slice(existingCount);
        this.animateCards(newCards);

        // Gérer la visibilité du bouton "Voir plus"
        if (this.moreBtn) {
          if (this.offset >= data.total) {
            this.moreBtn.classList.add('is-hidden');
          } else {
            this.moreBtn.classList.remove('is-hidden');
          }
        }
      });
  }
}
